'use client';
import { ReactAlertAtom } from '@/legacy/components/widget/Chat';
import { useGetCurrentOwner } from '@/model/dexie/ownerDexie';
import { promiseNotNullCheck } from '@/utilities/stateTool';
import * as ChannelService from '@channel.io/channel-web-sdk-loader';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

type Props = {};

const trigger = {
	hideChannelButtonOnBoot: true,
	hidePopup: true,
};

const ChannelTalk = (props: Props) => {
	const user = useGetCurrentOwner();
	const setBadge = useSetAtom(ReactAlertAtom);

	useEffect(() => {
		ChannelService.loadScript();

		if (promiseNotNullCheck(user)) {
			ChannelService.boot(
				{
					memberId: user.id, // fill your plugin key
					pluginKey: '90fc08da-c331-4b94-b221-09ecf2108621', // fill user's member id
					profile: {
						mobileNumber: null, // fill user's name
						name: user.nickname,
					},
					...trigger,
				},
				function onBoot(error, user) {
					if (error) {
						console.error(error);
					} else {
						// console.log('boot success', user)
						setBadge(user ? user.alert : 0);
					}
				}
			);
		} else {
			ChannelService.boot(
				{
					pluginKey: '90fc08da-c331-4b94-b221-09ecf2108621', // fill your plugin key
					...trigger,
				},
				function onBoot(error, user) {
					if (error) {
						console.error(error);
					} else {
						// console.log('boot success', user)
						setBadge(user ? user.alert : 0);
					}
				}
			);
		}

		ChannelService.onBadgeChanged((unread: number, alert: number) => {
			setBadge(alert);
		});
	}, [user]);
	return null;
};

export default ChannelTalk;
